// Components==============
import { KeyboardContext } from 'components/Layout/ControlBar/components/Keyboard/Keyboard';
import { motion } from 'framer-motion';
import React, { useContext } from 'react';
import { GlobalContext } from 'utilities/GlobalContext';
import './MultiKeyboardBlocks.module.scss';
// =========================

export default function MultiKeyboardBlocks({
    children,
    letters,
}: {
    children: React.ReactNode;
    letters: string;
}) {
    const { setKeyboardInput } = useContext(GlobalContext);
    const { isKeyboard } = useContext(KeyboardContext);

    function handleClick() {
        if (!isKeyboard) return;
        setKeyboardInput((prev) => [...prev, letters]);
    }

    return (
        <motion.div
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            styleName="wrapper"
            onClick={handleClick}
        >
            {children}
        </motion.div>
    );
}
